import { module } from 'modujs';
import * as basicLightbox from 'basiclightbox';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        console.log(basicLightbox);

        this.instance = null;
        
        this.el.addEventListener('click', (e) => {
            e.preventDefault();
            if (!this.instance) {
                this.instance = basicLightbox.create(`
                    <img src="${this.el.getAttribute('data-url')}" />
                `);
            }
            
            this.instance.show();
        });
    }
}
